// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__G6EXO","sticky":"styles_sticky__154Zc"};